export default __webpack_public_path__ + "static/media/boxes_blue.2f016def.svg";